

























































































import { Component, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import LoaderMixin from "@/mixins/loader";
import { getUserSubmissions, downloadFile } from "@/services/api/submission";
import NotificationMixin from "../../mixins/notification";
import { saveAs } from "file-saver";
import { getUsers, upgradeUser } from "../../services/user";

@Component({
  components: {}
})
export default class Submissions extends mixins(
  LoaderMixin,
  NotificationMixin
) {
  private refreshing = false;
  private submissionId: number = 0;
  private loading = false;
  private search = "";
  private selected: any = [];
  private date: Date = null;
  private headers = [
    {
      text: "Número",
      align: "center",
      value: "id"
    },
    { text: "Nome", align: "center", value: "name" },
    { text: "Email", align: "center", value: "email" },
    { text: "Data de inscrição", align: "center", value: "created_at" },
    { text: "", align: "center", value: "actions" }
  ];

  private users: any = [];

  private created() {
    this.loadData();
  }

  private loadData() {
    this.loading = true;
    this.refreshing = true;
    getUsers()
      .then(result => {
        this.loading = false;
        if (result.success) {
          result.data.forEach((user: any) => {
            user.created_at = new Date(user.created_at).toLocaleDateString();
          });
          this.users = result.data;
          this.loading = false;
          this.refreshing = false;
        } else {
          this.showServerErorNotification();
        }
      })
      .catch(err => {
        this.showServerErorNotification();
        this.loading = false;
        this.refreshing = false;
      });
  }

  private upgradeUser(email: string) {
    upgradeUser(email, "proofreader")
      .then(result => {
        if (result.success) {
          this.showSuccessNotification(
            "Inscrito promovido para revisor com sucesso."
          );
        } else {
          this.showErrorNotification("Ocorreu um erro ao promover usuário.");
        }
      })
      .catch(err => {
        this.showServerErorNotification();
      });
  }
}
